import React from 'react';
// import Categories from 'dummy/categories';
import {CategoryBox} from 'components/category';
import {connect} from 'react-redux';
import {Categories} from 'base/api';
import Masonry from 'react-masonry-component';

class CategoryList extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    if (this.props.categoriesAsTree.length == 0) {
      this.props.dispatch(Categories.actions.list());
    }
  }

  render() {
    let masonryOptions = {
      transitionDuration: 0
    };

    return (
      this.props.categoriesAsTree && this.props.categoriesAsTree.length > 0 &&
      <Masonry
        ref={function(c) {this.masonry = this.masonry || c.masonry;}.bind(this)}
        className={'my-gallery-class'} // default ''
        elementType={'div'} // default 'div'
        options={masonryOptions} // default {}
        disableImagesLoaded={true} // default false
        updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
      >
        {
          this.props.categoriesAsTree.map(item => {
            return <CategoryBox key={item.id} data={item}/>;
          })
        }
      </Masonry>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    categoriesAsTree: state.categoriesAsTree
  };
}

export default connect(mapStateToProps)(CategoryList);



// WEBPACK FOOTER //
// ./components/category/CategoryList.jsx